import { Tooltip } from '@mui/material';
import React from 'react';

import BinanceIcon from '../../../assets/icons/binance-icon.svg';
import CoincallIcon from '../../../assets/icons/coincall-icon.svg';
import DeribitIcon from '../../../assets/icons/deribit-icon.svg';
import OkxIcon from '../../../assets/icons/okx-icon.svg';
import OtcIcon from '../../../assets/icons/otc-icon.svg';
import { BLUR_STYLE } from '../../../providers/demo-blur';
import { Radio } from '../../../components/radio';
import Utils from '../../../utils/immersive_utils';

interface AlphabeticalAccountListProps {
  accounts: any[];
  isPortfolioSidebarOpen: boolean;
  selectedAccountOption: any;
  handleOptionChange: (account: any) => void;
  isDisabledAccounts: boolean;
  calculatedAccountNames: Set<string>;
  // Opt-in "blur names for demo" (Portfolio Management). Off by default.
  isBlurred?: boolean;
}

export const AlphabeticalAccountList: React.FC<AlphabeticalAccountListProps> = ({
  accounts,
  isPortfolioSidebarOpen,
  selectedAccountOption,
  handleOptionChange,
  isDisabledAccounts,
  calculatedAccountNames,
  isBlurred = false,
}) => {
  const sortedAccounts = accounts
    .map((account) => ({
      ...account,
      icon:
        account.exchange === 'binance'
          ? BinanceIcon
          : account.exchange === 'coincall'
            ? CoincallIcon
            : account.exchange === 'deribit'
              ? DeribitIcon
              : account.exchange === 'okx'
                ? OkxIcon
                : OtcIcon,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="portfolio-accounts-alphabetical">
      {sortedAccounts.map((account, index) => {
        const isCalculated = calculatedAccountNames.has(account.name);

        return (
          <Tooltip
            key={`${account.name}-${index}`}
            title={!isBlurred && account.name.length >= 20 ? account.name : ''}
          >
            <div
              className={`portfolio-accounts-area-radio ${isPortfolioSidebarOpen && 'radio-hover'}`}
            >
              <Radio
                label={
                  <div className="portfolio-accounts-alphabetical-item">
                    <img src={account.icon} alt={account.exchange} className="account-icon" />
                    <span style={isBlurred ? BLUR_STYLE : undefined}>
                      {Utils.truncateLabel(account.name)}
                    </span>
                  </div>
                }
                checked={selectedAccountOption.name === account.name}
                onChange={() => handleOptionChange(account)}
                disabled={isDisabledAccounts}
              />
              {isPortfolioSidebarOpen && isCalculated && (
                <div className="portfolio-accounts-circle-calculated" />
              )}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
};
